import {
  SELECT_FIELD_FOR_DETAIL,
  GET_ACCOUNT_FIELDS_REQUEST ,
  GET_ACCOUNT_FIELDS_FAILURE,
  GET_ACCOUNT_FIELDS_SUCCESS,

  FIELD_POST_REQUEST,
  FIELD_POST_SUCCESS,
  FIELD_POST_FAILURE,

  FIELD_PATCH_REQUEST,
  FIELD_PATCH_SUCCESS,
  FIELD_PATCH_FAILURE,

  DELETE_FIELD_REQUEST,
  DELETE_FIELD_SUCCESS,
  DELETE_FIELD_FAILURE,

  GET_FIELD_MAP_REQUEST,
  GET_FIELD_MAP_SUCCESS,
  GET_FIELD_MAP_FAILURE
} from './fieldActions';
import { decodeFieldPaths } from '../../common/utils/geoHelpers';

const initialState = {
  pending: false,
  hasError: false,
  error: null,
  fieldEntities: {},
  selectedFieldId: '',
  isFetchingMap: false,
  mapData: {}
};

const fieldsReducer = (state = { ...initialState }, action) => {
  switch(action.type) {

    ////////////////////////
    // Get Handlers
    ////////////////////////
    case GET_ACCOUNT_FIELDS_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case GET_ACCOUNT_FIELDS_SUCCESS: {
      const fieldEntities = {};
      const payloadWithSVG = decodeFieldPaths(action.payload);
      payloadWithSVG.forEach(entity => {
        fieldEntities[entity.id] = entity;
      });
      return {
        ...state,
        pending: false,
        hasError: false,
        fieldEntities
      };
    }
    case  GET_ACCOUNT_FIELDS_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }
    case SELECT_FIELD_FOR_DETAIL: {
      return {
        ...state,
        selectedFieldId: action.fieldId
      };
    }

    ////////////////////////
    // Create/Update Field Handlers
    ////////////////////////
    case FIELD_POST_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case FIELD_POST_SUCCESS: {
      const fieldEntities = { ...state.fieldEntities, [action.payload.id]: (decodeFieldPaths([action.payload]))[0] };

      return {
        ...state,
        pending: false,
        hasError: false,
        fieldEntities
      }
    }
    case FIELD_POST_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }

    case FIELD_PATCH_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case FIELD_PATCH_SUCCESS: {
      const fieldEntities = { ...state.fieldEntities, [action.payload.id]: (decodeFieldPaths([action.payload]))[0] };
      return {
        ...state,
        pending: false,
        hasError: false,
        fieldEntities
      }
    }
    case FIELD_PATCH_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }

    ////////////////////////
    // Delete Handlers
    ////////////////////////
    case DELETE_FIELD_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case DELETE_FIELD_SUCCESS: {
      const { fieldId } = action;
      delete state.fieldEntities[fieldId];
      const newFieldEntities = Object.assign({}, state.fieldEntities);
      return {
        ...state,
        pending: false,
        hasError: false,
        fieldEntities: newFieldEntities
      }
    }

    case DELETE_FIELD_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }
    ////////////////////////
    // Get Map  Handlers
    ////////////////////////
    case GET_FIELD_MAP_REQUEST: {
      return { ...state, isFetchingMap: true };
    }
    case GET_FIELD_MAP_SUCCESS: {
      const { fieldId, key, payload} = action;
      let fieldMaps =  {...state.mapData[fieldId]}
      fieldMaps[key] = payload.data
      return {
        ...state,
        isFetchingMap: false,
        mapData: {...state.mapData, [fieldId]: fieldMaps},
        hasError: false,
        error: null
      }
    }

    case GET_FIELD_MAP_FAILURE: {
      return {
        ...state,
        isFetchingMap: false,
        hasError: true,
        error: action.error
      };
    }

    default: {
      return state;
    }
  }
}

export default fieldsReducer;
